// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__irI21","footer":"NavbarSimple_footer__GutZs","link":"NavbarSimple_link__2Eh-P","linkIcon":"NavbarSimple_linkIcon__GYmCm"};